import styled from "styled-components";

export const HeatNumbersDropdownContainer = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    // height: 7rem;
    max-height: 10rem;
    padding-bottom: 0.15rem;
    background-color: #fff;
    border: 1px solid #ebebeb;
    border-top-left-radius: 0.8rem;
    border-bottom-left-radius: 0.8rem;
    border-bottom-right-radius: 0.8rem;
    box-shadow: 0px 8px 16px 0px #0000001A;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 1;
    
    .addDiv {
        border-bottom: 2px solid #ebebeb;
        min-height: 2.2rem;
        max-height: 2.2rem;
    }

    .addText {
        margin-left: 0.4rem;
    }
`

export const HeatNumberOptionDiv = styled.div`
    display: flex;
    width: 12rem;
    align-items: center;
    height: 3rem;
    cursor: pointer;
    padding: .8rem;

    :hover{
        background-color: #EBEBEB;
    }
`

export const HeatNumberOptionText = styled.p`
    font-size: clamp(0.7rem, calc(0.7rem + 0.1vw) , 1.3rem);
    font-family: 'Inter', sans-serif;
    user-select: none;
`